import script from "./QRfidFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./QRfidFilters.vue?vue&type=script&setup=true&lang=js"

import "./QRfidFilters.vue?vue&type=style&index=0&id=6b247d3c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b247d3c"]])

export default __exports__